import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade';

import main from '../../img/AboutUs/main.png'
import mainm from '../../img/AboutUs/main-mob.png'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
                <div className="flex flex-col xl:flex-row gap-[20px] justify-between">
                    <div className="xl:mt-[120px]">
                        <p className="text-[32px] xl:text-[50px] italic font-[700] merriweather"><Trans>{t('about.1')}</Trans></p>
                        <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] mt-[30px] inter">{t('about.2')}</p>
                        <div className="flex items-center gap-[13px] mt-[15px] xl:mt-[30px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                <path d="M13.5 0C6.05618 0 0 6.05618 0 13.5C0 20.9438 6.05618 27 13.5 27C20.9438 27 27 20.9438 27 13.5C27 6.05618 20.9438 0 13.5 0ZM11.0337 20.2747L5.8024 14.4612L7.34647 13.0716L10.9811 17.11L19.601 6.84476L21.1937 8.17789L11.0337 20.2747Z" fill="black"/>
                            </svg>
                            <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] inter">{t('about.3')}</p>
                        </div>
                        <div className="flex items-center gap-[13px] mt-[15px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                <path d="M13.5 0C6.05618 0 0 6.05618 0 13.5C0 20.9438 6.05618 27 13.5 27C20.9438 27 27 20.9438 27 13.5C27 6.05618 20.9438 0 13.5 0ZM11.0337 20.2747L5.8024 14.4612L7.34647 13.0716L10.9811 17.11L19.601 6.84476L21.1937 8.17789L11.0337 20.2747Z" fill="black"/>
                            </svg>
                            <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] inter">{t('about.4')}</p>
                        </div>
                        <div className="flex items-center gap-[13px] mt-[15px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                <path d="M13.5 0C6.05618 0 0 6.05618 0 13.5C0 20.9438 6.05618 27 13.5 27C20.9438 27 27 20.9438 27 13.5C27 6.05618 20.9438 0 13.5 0ZM11.0337 20.2747L5.8024 14.4612L7.34647 13.0716L10.9811 17.11L19.601 6.84476L21.1937 8.17789L11.0337 20.2747Z" fill="black"/>
                            </svg>
                            <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] inter">{t('about.5')}</p>
                        </div>
                        <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] mt-[15px] xl:mt-[30px] inter">{t('about.6')}</p>
                    </div>
                    <div>
                        <Fade right><img src={main} className="hidden xl:block " alt="" /></Fade>
                        <Fade><img src={mainm} className="xl:hidden mx-auto" alt="" /></Fade>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;